import { useMemo, useRef } from 'react';

/**
 * @param o the object you want to compare for each render
 * @returns the times that o changes compared by `useMemo`.
 *  Useful to get the version of React Query data.
 */
export const useMemoVersion = (o: unknown) => {
  const version = useRef(1);

  return useMemo(() => {
    return version.current++;
  }, [o]);
};
